import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  newSectionButton: {
    id: 'course-authoring.course-outline.header-navigations.button.new-section',
    defaultMessage: 'Add Section',
  },
  newSectionButtonTooltip: {
    id: 'course-authoring.course-outline.header-navigations.button.new-section.tooltip',
    defaultMessage: 'Click to add a new section',
  },
  reindexButton: {
    id: 'course-authoring.course-outline.header-navigations.button.reindex',
    defaultMessage: 'Reindex',
  },
  reindexButtonTooltip: {
    id: 'course-authoring.course-outline.header-navigations.button.reindex.tooltip',
    defaultMessage: 'Reindex current course',
  },
  expandAllButton: {
    id: 'course-authoring.course-outline.header-navigations.button.expand-all',
    defaultMessage: 'Expand all',
  },
  collapseAllButton: {
    id: 'course-authoring.course-outline.header-navigations.button.collapse-all',
    defaultMessage: 'Collapse all',
  },
  viewLiveButton: {
    id: 'course-authoring.course-outline.header-navigations.button.view-live',
    defaultMessage: 'View live',
  },
  viewLiveButtonTooltip: {
    id: 'course-authoring.course-outline.header-navigations.button.view-live.tooltip',
    defaultMessage: 'Click to open the courseware in the LMS in a new tab',
  },
});

export default messages;
